/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useMemo, useState } from 'react';
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, textureAnisotropy } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { MaterialInnerWall } from '../../../../CustomMaterial';
import useMouseEvents from '../../../../../../hooks/useMouseEvents';

const InsideWallModel = () => {
    const { gl } = useThree();

    const [wallCloseState, setWallCloseState] = useState(0);
    const [leftStorageWallHeight, setLeftStorageWallHeight] = useState(params.p_h);
    const [rightStorageWallHeight, setRightStorageWallHeight] = useState(params.p_h);

    // const texture = const_var.metalTexture
    
    const leftHeight = useMemo(() => ((params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) :  params.p_h), [params.singleSlope, params.freeStandingSide, params.p_w, params.p_h, params.p_r_p])
    const rightHeight = useMemo(() => ((params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) :  params.p_h), [params.singleSlope, params.freeStandingSide, params.p_w, params.p_h, params.p_r_p])

    const wallModel = useMemo(() => {
        let model = new THREE.Shape();

        if (wallCloseState > -1) {
            if (params.p_r_s === 1) {
                const innerRoofWidth = params.p_w - 0.01
                                
                model.moveTo(-params.p_w / 2, params.p_h);
                model.lineTo(-params.p_w / 2 + 0.01, params.p_h + const_var.roofRegularDst);
                model.quadraticCurveTo( -params.p_w / 2 + 0.02, params.p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.p_r_p / 12) / 10,
                                        -params.p_w / 2 + 0.01 + const_var.roofRegularDst, params.p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
                                        
        
                model.lineTo(0, params.p_h + ((params.p_r_p / 12) * (params.p_w/2)) + const_var.roofRegularDst * 2 - 0.03);
        
                model.lineTo(params.p_w / 2 - 0.01 - const_var.roofRegularDst, params.p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
                model.quadraticCurveTo( params.p_w / 2 - 0.01, params.p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.p_r_p / 12) / 10,
                                        params.p_w / 2 - 0.01, params.p_h + const_var.roofRegularDst);
                model.lineTo(params.p_w / 2 - 0.01, params.p_h);
                model.lineTo(innerRoofWidth / 2 +0.005, wallCloseState);

                if (rightStorageWallHeight !== 0) {
                    model.lineTo(innerRoofWidth / 2 +0.005, 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) , 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) , wallCloseState);
                }

                if (leftStorageWallHeight !== 0) {
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), wallCloseState);
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                    model.lineTo(-innerRoofWidth / 2 +0.005, 0);
                }

                model.lineTo(-innerRoofWidth / 2 +0.005, wallCloseState);
        
                model.closePath()
        
            } else if (params.p_r_s === 2 || params.p_r_s === 3) {
                model.moveTo(-params.p_w / 2, leftHeight -0.001);
                if(!params.singleSlope) model.lineTo(0, params.p_h + (params.p_r_p / 12) * params.p_w / 2);
                model.lineTo(params.p_w / 2, rightHeight - 0.001);
                model.lineTo(params.p_w / 2, wallCloseState);

                if (rightStorageWallHeight !== 0) {
                    model.lineTo(params.p_w / 2, 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) , 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) , wallCloseState);
                }

                if (leftStorageWallHeight !== 0) {
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), wallCloseState);
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                    model.lineTo(-params.p_w / 2, 0);
                }

                model.lineTo(-params.p_w / 2, wallCloseState);
                model.closePath()
            }
        } else {
            if (leftStorageWallHeight !== 0) {
                if (params.p_r_s === 1) {
                    const innerRoofWidth = params.p_w - 0.01
                    
                    model.moveTo(-params.p_w / 2 + 0.01, params.p_h);
                    model.lineTo(-params.p_w / 2 + 0.01, params.p_h + const_var.roofRegularDst);
                    model.quadraticCurveTo( -params.p_w / 2 + 0.01, params.p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.p_r_p / 12) / 10,
                                            -params.p_w / 2 + 0.01 + const_var.roofRegularDst, params.p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
                                            
                    if (parseInt(params.cB_addStorage_left) >= params.p_w / 2) {
                        model.lineTo(0, params.p_h + ((params.p_r_p / 12) * (params.p_w / 2)) + const_var.roofRegularDst * 2 - 0.03);
                    }

                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), leftStorageWallHeight - 0.02);
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                    model.lineTo(-innerRoofWidth / 2 +0.005, 0);
            
                    model.closePath()
            
                } else if (params.p_r_s === 2 || params.p_r_s === 3) {
                    model.moveTo(-params.p_w / 2, leftHeight - 0.001);
                    if (parseInt(params.cB_addStorage_left) > params.p_w / 2) {
                        if(!params.singleSlope) model.lineTo(0, params.p_h + (params.p_r_p / 12) * params.p_w / 2);
                    }
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), leftStorageWallHeight - 0.02);
                    model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                    model.lineTo(-params.p_w / 2, 0);
                    model.closePath()
                }
            }

            if (rightStorageWallHeight !== 0) {
                if (params.p_r_s === 1) {
                    const innerRoofWidth = params.p_w - 0.01
                    
                    model.moveTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), rightStorageWallHeight - 0.02);
                    if (parseInt(params.cB_addStorage_right) >= params.p_w / 2) {
                        model.lineTo(0, params.p_h + ((params.p_r_p / 12) * (params.p_w / 2)) + const_var.roofRegularDst * 2 - 0.03);
                    }
                    model.lineTo(params.p_w / 2 - 0.01 - const_var.roofRegularDst, params.p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
                    model.quadraticCurveTo( params.p_w / 2 - 0.01, params.p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.p_r_p / 12) / 10,
                                            params.p_w / 2 - 0.01, params.p_h + const_var.roofRegularDst);
                    model.lineTo(params.p_w / 2 - 0.01, params.p_h);
                    model.lineTo(innerRoofWidth / 2 +0.005, 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0);
                    model.closePath()
            
                } else if (params.p_r_s === 2 || params.p_r_s === 3) {
                    model.moveTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), rightStorageWallHeight - 0.02);

                    if (parseInt(params.cB_addStorage_right) > params.p_w / 2) {
                        if(!params.singleSlope) model.lineTo(0, params.p_h + (params.p_r_p / 12) * params.p_w / 2);
                    }

                    model.lineTo(params.p_w / 2, rightHeight - 0.001);
                    model.lineTo(params.p_w / 2, 0);
                    model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0);
                    model.closePath()
                }
            }
        }

        return model;
    
    }, [params.cB_addStorage_left, params.cB_addStorage_right, wallCloseState, params.p_r_s, params.p_w, params.p_r_p, params.p_h, rightStorageWallHeight, leftStorageWallHeight, params.singleSlope && params.freeStandingSide === "left"])

    const dutchDelModel = useMemo(() => {
        const freeSpace = 1;
        const cornerFreeSpaceW = freeSpace * 2;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) :  params.p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = cornerFreeSpaceW;
        
        if (/* !params.cB_addStorage_check_right && !params.cB_addStorage_check_right && */ (params.p_b_w === "Half Dutch End" || params.p_b_w === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.p_w / 2 - freeSpace), 0);

            if (params.p_b_w === "Half Dutch End") {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
            } else {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace);
            }
            model.lineTo((params.p_w / 2 - freeSpace), 0);

            return model;
        } else {
            return []
        }
    }, [params.p_w, params.p_h, params.p_b_w])
    
    /************** cutting hole using CSG ***************/
    const CSGWallModelGeometry = useMemo(() => {
        const meshWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wallModel, extrudeSettings(0.005)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('back', 'wall'), extrudeSettings(1)))
        const meshDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModel, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshWallModel_Temp = meshWallModel.clone();
        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(0, 0, -0.5);

        // mesh to cut the dutch model
        let meshDutchDelModel_Temp = meshDutchDelModel.clone();

        const meshWallModel_CSG = CSG.fromMesh(meshWallModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshDutchDelModel_CSG = CSG.fromMesh(meshDutchDelModel_Temp);

        const wallModel_CSG = meshWallModel_CSG.subtract(meshDelModel_CSG);
        const FrontWallModel_CSG = wallModel_CSG.subtract(meshDutchDelModel_CSG);
        const CSGWallModel = CSG.toMesh(
            FrontWallModel_CSG,
            new THREE.Matrix4(),
        )

        // setCSGWallModelGeometry(CSGWallModel.geometry);

        return CSGWallModel.geometry;

    }, [params.endStoragePositionZ, wallModel, params.p_w, params.p_h, params.p_b_w, wallCloseState, params.p_r_s, params.p_r_p, rightStorageWallHeight, leftStorageWallHeight, params.singleSlope && params.freeStandingSide === "left", const_var.newDoorsArray]);

    useMemo(() => {
        let wallCloseValue = -1;
        let leanHeightValue = -1;

        if (params.p_b_w === 'Open') {
            wallCloseValue = -1;
        } else if (params.p_b_w === "Gable") {
            wallCloseValue = leftHeight - 0.2;
        } else if (params.p_b_w === "Extended Gable") {
            wallCloseValue = leftHeight - 3;
        } else if (params.p_b_w === "One_Fourth_Close") {
            wallCloseValue = (leftHeight * 3) / 4;
        } else if (params.p_b_w === "Half_Close") {
            wallCloseValue = leftHeight / 2;
        } else if (params.p_b_w === "Three_Fourth_Close") {
            wallCloseValue = leftHeight / 4;
        } else if (params.p_b_w === "Close" || params.p_b_w === "Half Dutch End" || params.p_b_w === "Half End") {
            wallCloseValue = 0;
        }
        if (params.add_back_lean) {
            let leanFinalHeight = params.p_h - (params.leanB_p_h + (params.leanStyle.back === "gable" ? 0.2 : (parseInt(params.b_l_t_r_pB) / 12 * params.leanB_p_w))) - (params.p_r_s === 1 && const_var.roofRegularDst * 2);
            if((Object.values(const_var.wallArray["back"])[0] == params.p_b_w || params.p_b_w == "Open")  && params.p_b_w != "Close")
            {    
              params.p_b_w = params.p_b_wB;
              let wH = Number((leanFinalHeight+0.2).toFixed(2));
              setWallCloseState(params.p_h - wH);

            }else{
                setWallCloseState(wallCloseValue);
            }
        } else {
            setWallCloseState(wallCloseValue);
        }
    
    }, [params.p_b_w, params.p_r_s, leftHeight, params.add_back_lean, params.leanB_p_h, params.leanB_p_w, params.b_l_t_r_pB, params.p_u_c, JSON.stringify(const_var.wallArray), params.leanStyle.back])

    useMemo(() => {
        if (params.cB_addStorage_check_left) {
            let overHeight = 0;
            if ((parseInt(params.cB_addStorage_left) < params.p_w / 2) || (params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right"))) {
                if (params.p_r_s === 1) {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + const_var.roofRegularDst * 2;
                } else {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                }
            } else {
                if (params.p_r_s === 1) {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + const_var.roofRegularDst * 2;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                }
            }
    
            setLeftStorageWallHeight(leftHeight + overHeight);
        } else {
            setLeftStorageWallHeight(0);
        }
    
    }, [params.cB_addStorage_check_left, params.cB_addStorage_left, params.p_r_s, params.p_r_p, params.p_w, params.p_h, params.singleSlope && params.freeStandingSide === "left", const_var.newDoorsArray])

    useMemo(() => {
        if (params.cB_addStorage_check_right) {
            let overHeight = 0;
            if (parseInt(params.cB_addStorage_right) < params.p_w / 2 && !params.singleSlope) {
                if (params.p_r_s === 1) {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + const_var.roofRegularDst * 2;
                } else {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                }
            } else {
                if (params.p_r_s === 1) {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + const_var.roofRegularDst * 2;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                }
            }
    
            setRightStorageWallHeight(leftHeight + overHeight);
        } else {
            setRightStorageWallHeight(0);
        }
    
    }, [params.cB_addStorage_check_right, params.cB_addStorage_right, params.p_r_s, params.p_r_p, params.p_w, leftHeight])
        
    const handleMouseEvent = (e) => {
        if (params.activeWall !== "c_b_b_s_w" && const_var.focusedSection == "center") {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

     


    return CSGWallModelGeometry && (
        <group {...eventHandlers}>
            <mesh name="back_leg_inside_wall" geometry={CSGWallModelGeometry} position={[0, 0, -(params.p_d / 2 + 0.1)]}>
                <MaterialInnerWall visibleSection={"center"} />
            </mesh>
        </group>
    )
}

export default InsideWallModel